import { jsx as _jsx } from "react/jsx-runtime";
import { Default, Plain, Thin } from './LegacyLink.styles';
const variantMap = {
    plain: Plain,
    thin: Thin,
    default: Default
};
/** @deprecated */ export const LegacyLink = ({ href, shouldOpenInNewTab, variant = 'default', ...props })=>{
    const Variant = variantMap[variant] ?? Default;
    return /*#__PURE__*/ _jsx(Variant, {
        href: href,
        target: shouldOpenInNewTab ? '_blank' : undefined,
        ...props
    });
};

//# sourceMappingURL=LegacyLink.js.map